import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import { 
  Paper, 
  InputBase, 
  IconButton, 
  Divider,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  Autocomplete,
  TextField
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import BusinessIcon from '@mui/icons-material/Business';
import WorkIcon from '@mui/icons-material/Work';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { mobileWidth } from "./components/constants.jsx";
import SmallBox from "./components/maintable/SmallBox.jsx";
import TextInputAutofill from "./components/textBoxAutofill.jsx";
import { denormalizeString, localizeVar, getCompanyDisplayName, forceLtrRange } from "./util.jsx";
import { GetAllCities } from "react-country-state-city";
import { useCompanies } from "./contexts/CompanyContext.jsx";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Alert, AlertTitle } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

var rolesData = require('../roles.json');
const Explore = () => {
  const { t, i18n } = useTranslation();
  const urloc = useLocation();
  const params = new URLSearchParams(urloc.search);
  const [location ,setLocation] = useState('');
  const [role, setRole] = useState('');
  const [company, setCompany] = useState('');
  // const [locations, setLocations] = useState(['location','another one']);
  const [roles, setRoles] = useState(['role']);
  const {companyLogos, companyDisplayNames, displayNamesByCompany } = useCompanies();
  const [result, setResult] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loaded, setLoaded ] = useState(false)
  

  useEffect(()=>{
    setRole('');
    setCompany('');
    // setLocation('');
    const query = {};

    if (params.get('role')) {
      const role = params.get('role');
      setRole(role);
      query.role = role;
    }

    if (params.get('company')) {
      const company = params.get('company');
      setCompany(company);
      query.company = company;
    }

    fetchData(query);
    // fetchLocations();
    fetchRoles();
  },
    [urloc]);

  // const fetchLocations = () =>{
  //   GetAllCities().then((result) => {
  //     setLocations(result.map((item) => (item.name)));
  //   }
  //   )
  // }
  const fetchRoles = async () =>{
    const role_names = []
      for (var i=0; i < rolesData.roles.length; i++){
        role_names.push(denormalizeString(rolesData.roles[i].role_name_en));
        role_names.push(denormalizeString(rolesData.roles[i].role_name_ar));
      }

      setRoles(role_names);
  }

  const fetchData = async ({role = '', location = '', company= '', page = 1, limit =21, loadNextPage = 0} = {}) => {
    // if (location) url += `&location_city=${encodeURIComponent(location)}`;

    const params = new URLSearchParams({
        limit: limit.toString(),
        page: page.toString(),
      });
    if (role) params.append('role', role);
    if (company) params.append('company_name', company);

    fetch(`/api/v1/salary?${params.toString()}`, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        if (loadNextPage === 0){
          setResult(JSON.parse(data.salaries));
        } else {
          setResult(prev => [...prev, ...JSON.parse(data.salaries)]);
        }
        
        setHasMore(page < data.total_pages);
        setLoaded(true);
      })
      .catch((error) => console.log(error));
  };


  const handleSearchChange = (setState) => (newValue) => {
    setState(newValue);
  }
  const handleSuggestionClick = (setState) => (newValue) => {
    setState(newValue);
  };

  const search = () => {
    console.log(`searching: ${role}, ${company}, ${location}`);
    setPage(1);
    fetchData({role:role, company:company, location:location});
  }

  const onLoadMoreClick = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchData({role:role, company:company, location:location, page:nextPage, loadNextPage:1});

  }

  const clear = () =>{
  setCompany('');
  setRole('');
  setPage(1);
  setHasMore(false);
  fetchData()
}

  return (
    <div dir={i18n.dir()}>
      <NavBar />
      <Title>{t("discover_title")}</Title>

      <SearchBarContainer>
        <SearchBar elevation={2}>
          <SearchSection>
            <WorkIcon sx={{ color: 'rgba(0, 0, 0, 0.54)', mx: 1 }} />
            <TextInputAutofill
            value={role}
            placeholder={t('search_role')}
            suggestionsList={roles}
            func={handleSearchChange(setRole)}
            listFunc={handleSearchChange(setRole)}
          />
          </SearchSection>
          
          
          <SearchSection>
            <BusinessIcon sx={{ color: 'rgba(0, 0, 0, 0.54)', mx: 1 }} />
            <TextInputAutofill
            value={company}
            placeholder={t('search_companies')}
            suggestionsList={companyDisplayNames}
            func={handleSearchChange(setCompany)}
            listFunc={handleSuggestionClick(setCompany)}
          />
          </SearchSection>
          
          {/* <SearchSection>
            <LocationOnIcon sx={{ color: 'rgba(0, 0, 0, 0.54)', mx: 1 }} />
            <TextInputAutofill
            value={location}
            placeholder={t("search_locations")}
            suggestionsList={locations}
            func={handleSearchChange(setLocation)}
            listFunc={handleSuggestionClick(setLocation)}
          />
          </SearchSection> */}

          <IconButton 
            onClick={search}
            sx={{ 
              mx: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            <SearchIcon />
          </IconButton>
        </SearchBar>
      </SearchBarContainer>
      
      <MainContainer>
      {result.length > 0 ? (<FlexCol>
        <ResultsSection>
          <CardContainer>
            {result.map((item, index) => {
              const currLang = i18n.resolvedLanguage;
              return(
              <SmallBox
              key={index}
              companyName={getCompanyDisplayName(item, currLang, displayNamesByCompany)}
              companyNameNormalized={item.company_name_en}
              roleName={denormalizeString(localizeVar(item, "role", currLang))}
              salary={`${item.salary_per_month.toLocaleString()}`}
              logo={companyLogos[item.company_name_en] || ""}
              createdAt={item.created_at}
              locationCity={denormalizeString(localizeVar(item, "location_city", currLang))}
              exp = {`${forceLtrRange(item.experience_in_yrs,currLang)} ${t("card_exp")}`}
            />)
            })}

          </CardContainer>
        </ResultsSection>
      {hasMore && <ShowMoreButton onClick={onLoadMoreClick}>Load More</ShowMoreButton>}
      </FlexCol>):
      ((loaded && <div style={{alignSelf:"center"}}><Alert icon={<ShareIcon />} severity="info">
                <NotFoundTitle>
                  <AlertTitle>{t("main_no_salaries")} </AlertTitle> 
                  <FindOutLink onClick={clear}>{t("reset search")}</FindOutLink>
                </NotFoundTitle>
                {t("main_no_salaries_details")}{' '}
                <FindOutLink style={{display:"inline"}} href="/addsalary">{t("main_no_salaries_link")}</FindOutLink> {t("main_no_salaries_details_part_2")}
              </Alert></div>))
      }
      </MainContainer>

      <Footer />
    </div>
  );
};

const MainContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;
const FlexCol =styled.div`
  display: flex;
  flex-direction: column;
`
const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const ResultsSection = styled.div`
  width: 100%;
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  justify-content: center;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${Colors.darkGray};
  text-align: center;
  text-transform: uppercase;
  margin: 50px;
  letter-spacing: 2px;
  margin-top:100px;
`;

const SearchBarContainer = styled.div`
display:flex;
  max-width: 800px;
  margin: 0 auto 40px auto;
  padding: 0 20px;
  justify-content: center;
`;

const SearchBar = styled(Paper)`
  width: fit-content;
  padding: 8px;
  display: flex;
  align-items: center;
  border-radius: 12px !important;
  align-self: center;
  @media (max-width: ${mobileWidth}){
    flex-direction: column;
    padding-inline-end:24px;
  }
`;

const SearchSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 200px;
`;

const ShowMoreButton = styled(SearchBar)`
  padding: 10px;
  margin: 28px;
  color: ${Colors.vividBlue};
  background-color: ${Colors.white};
    border-radius: 12px;
  padding: 16px;
  background-color: ${Colors.white};
  box-sizing: border-box;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  cursor: pointer;  /* Make the box visually clickable */

  &:hover {
    transform: scale(1.05);
  }
`;
const NotFoundTitle = styled(FlexRow)`
  justify-content :space-between;
` 
const FindOutLink = styled.a`
  color: #0395ff;
  text-decoration: none;
  font-weight: 300;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #0458a2;
  }
`;
export default Explore;
